<template>
<b-form-group align="left">
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <label> Estados: </label>
    <b-form-select   v-model="estado"  v-if="!loading" >
    <b-form-select-option value="0">Todos</b-form-select-option>
        <b-form-select-option v-for="elemento in estados" :key="elemento.idEstado" :value="elemento.idEstado">{{ elemento.nombreEstado }}</b-form-select-option>
    </b-form-select>
    <b-spinner small v-if="loading"></b-spinner>
</b-form-group>
</template>

<script>
export default {
    name: "Estados",
    props: { 
    }, 
    watch: { 
        estado: function() {
            this.$emit("_setearValor", {propiedad : "estado", valor : this.estado});
            this.$forceUpdate();
        },
    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
        estados: [],
        estado: null,
        loading: true,

    }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
    methods: {
        getObtenerClinicasActivas() {
            this.$http
                .get(this.$api + "catalogos/listaEstados")
                .then((response) => {
                    this.estados = response.data.data;
                })
                .catch((error) => {
                    console.error(error);
                }).finally(() =>   
                    this.loading = false
                );
        },
    },
    mounted() {
        this.getObtenerClinicasActivas();
    },
}
</script>
